import { render, staticRenderFns } from "./BelongSupDialog.vue?vue&type=template&id=79fc40e1&"
import script from "./BelongSupDialog.vue?vue&type=script&lang=js&"
export * from "./BelongSupDialog.vue?vue&type=script&lang=js&"
import style0 from "./BelongSupDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports